import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function AdminSettings() {
  const [adminLineUserId, setAdminLineUserId] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${API_URL}/api/admin-settings`);
      const data = await response.json();
      if (data.success && data.settings.admin_line_user_id) {
        setAdminLineUserId(data.settings.admin_line_user_id);
      }
    } catch (error) {
      console.error('設定取得エラー:', error);
    }
  };

  const handleSave = async () => {
    try {
      const response = await fetch(`${API_URL}/api/admin-settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          key: 'admin_line_user_id',
          value: adminLineUserId
        })
      });

      const data = await response.json();

      if (data.success) {
        setMessage('設定を保存しました！');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      console.error('設定保存エラー:', error);
      setMessage('保存に失敗しました');
    }
  };

  return (
    <div>
      <h2>管理者設定</h2>

      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '10px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h3>LINE通知設定</h3>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          住民が友だち追加したとき、管理者のLINEに通知を送ります。
          管理者のLINE User IDを設定してください。
        </p>

        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '10px',
            fontWeight: 'bold'
          }}>
            管理者のLINE User ID
          </label>
          <input
            type="text"
            value={adminLineUserId}
            onChange={(e) => setAdminLineUserId(e.target.value)}
            placeholder="例: Ua2a15ae477ab1cc8142d5f31e87dc923"
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
          <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#666' }}>
            ※LINE公式アカウントに「こんにちは」などメッセージを送ると、返信にUser IDが含まれます
          </p>
        </div>

        <button
          onClick={handleSave}
          style={{
            padding: '12px 30px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '16px'
          }}
        >
          保存
        </button>

        {message && (
          <p style={{
            marginTop: '15px',
            color: message.includes('失敗') ? '#f44336' : '#4CAF50',
            fontWeight: 'bold'
          }}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
}

export default AdminSettings;
